export default "__VITE_ASSET__D77sAMhH__"